const ScoreSections = {
    ANSWERPATTERN: "answerPattern",
    DILEMMATEST: "dilemmaTest",
    HEXIT: "hexit",
    PERSONALITYBUILDINGDOCKS: "intermediatePersonalityBuildingDocks",
    RISKINDICATIONBUILDINGDOCKS: "intermediateRiskIndication",
};

export default ScoreSections;
